import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./styles.scss";
import { HiChartSquareBar } from "react-icons/hi";
import {
  FaStore,
  FaShoppingBag,
  FaMapMarked,
  FaListAlt,
  FaUsers,
  FaMobileAlt,
  FaUserCheck,
  FaWhatsapp,
  FaHistory,
  FaChevronDown,
  FaLightbulb,
} from "react-icons/fa";
import { FiGrid } from "react-icons/fi";

export default function SidebarPanelNavigation({ isAdmin }) {
  const location = useLocation();
  const [isLeadsMenuOpen, setIsLeadsMenuOpen] = useState(true);

  useEffect(() => {
    if (location.pathname.includes("/leads")) {
      setIsLeadsMenuOpen(true);
    }
  }, [location.pathname]);

  const renderLeadsMenu = (basePath) => (
    <li>
      <div className="sidebar-menu-toggle">
        <FaUserCheck size={20} />
        <Link className="ml-2 text-secondary" to={`${basePath}/overview`}>
          Leads
        </Link>
        <button
          type="button"
          className={`submenu-caret ${isLeadsMenuOpen ? "is-open" : ""}`}
          onClick={() => setIsLeadsMenuOpen((prev) => !prev)}
          aria-label="Abrir submenu de Leads"
          aria-expanded={isLeadsMenuOpen}
        >
          <FaChevronDown size={13} />
        </button>
      </div>

      {isLeadsMenuOpen && (
        <ul className="sidebar-submenu">
          <li>
            <Link className="text-secondary" to={`${basePath}/overview`}>
              Visão geral
            </Link>
          </li>
          <li>
            <Link className="text-secondary" to={`${basePath}/insights`}>
              Interesses e respostas
            </Link>
          </li>
          <li>
            <Link className="text-secondary" to={`${basePath}/management`}>
              Gestão e disparos
            </Link>
          </li>
        </ul>
      )}
    </li>
  );

  const renderNavigation = () => {
    return (
      <nav className="text-secondary">
        {isAdmin && (
          <ul>
            <li>
              <HiChartSquareBar size={20} />
              <Link className="ml-2 text-secondary" to="/admin/dashboard">
                Dashboard
              </Link>
            </li>
            <li className="my-2">
              <FaStore size={20} />
              <Link className="ml-2 text-secondary" to="/admin/usuarios">
                Usuários
              </Link>
            </li>

            <li className="my-2">
              <FaMapMarked size={20} />
              <Link className="ml-2 text-secondary" to="/admin/localidades">
                Localidades
              </Link>
            </li>
            <li>
              <FiGrid size={20} />
              <Link className="ml-2 text-secondary" to="/admin/categorias">
                Categorias
              </Link>
            </li>
            <br />
            <li>
              <FiGrid size={20} />
              <Link className="ml-2 text-secondary" to="/admin/parceiros">
                Parceiros
              </Link>
            </li>
            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/tipos-categorias">
                Tipos de Categorias
              </Link>
            </li>
            <br />
            <li>
              <FaShoppingBag size={20} />
              <Link className="ml-2 text-secondary" to="/admin/products">
                Todos os Produtos
              </Link>
            </li>

            <br />
            <li>
              <FaLightbulb size={20} />
              <Link className="ml-2 text-secondary" to="/adicionar-oferta-ia">
                Nova Oferta com IA
              </Link>
            </li>

            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/banner">
                Todos os Banners
              </Link>
            </li>
            <br />
            <li>
              <FaListAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/ribbon-badges">
                Todos os Emblemas
              </Link>
            </li>

            <br />
            <li>
              <FaUsers size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-geral">
                Grupo Geral
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-celular">
                Grupo Celular
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-xiaomi">
                Grupo Xiaomi
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-samsung">
                Grupo Samsung
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-motorola">
                Grupo Motorola
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-apple">
                Grupo Apple
              </Link>
            </li>
            <li>
              <FaMobileAlt size={20} />
              <Link className="ml-2 text-secondary" to="/admin/grupos-hiperfoco">
                Grupo Hiperfoco
              </Link>
            </li>

            <br />
            {renderLeadsMenu("/admin/leads")}
            <br />
            <li className="my-2">
              <FaWhatsapp size={20} />
              <Link className="ml-2 text-secondary" to="/admin/automacao-whatsapp">
                Automação WhatsApp
              </Link>
            </li>
            <br />
            <li>
              <FaHistory size={20} />
              <Link className="ml-2 text-secondary" to="/admin/historico-mensagens">
                Histórico de mensagens
              </Link>
            </li>
          </ul>
        )}
        {!isAdmin && (
          <ul>
            <li className="my-2">
              <FaStore size={20} />
              <Link className="ml-2 text-secondary" to="/poster/produtos">
                Meus Produtos
              </Link>
            </li>
            <br />
            <li className="my-2">
              <FaLightbulb size={20} />
              <Link className="ml-2 text-secondary" to="/adicionar-oferta-ia">
                Nova Oferta com IA
              </Link>
            </li>
            <br />
            {renderLeadsMenu("/poster/leads")}
            <br />
            <li className="my-2">
              <FaWhatsapp size={20} />
              <Link className="ml-2 text-secondary" to="/poster/automacao-whatsapp">
                Automação WhatsApp
              </Link>
            </li>
            <br />
            <li>
              <FaHistory size={20} />
              <Link className="ml-2 text-secondary" to="/poster/historico-mensagens">
                Histórico de mensagens
              </Link>
            </li>
          </ul>
        )}
      </nav>
    );
  };

  return (
    <div className="sidebar-panel-nav d-none d-sm-nome d-md-none d-lg-block  text-secondary" style={{ background: "#000" }}>
      {isAdmin && <h5 className="mb-4">Painel de Controle</h5>}
      {!isAdmin && <h5 className="mb-4">Painel do Postador</h5>}
      {renderNavigation()}
    </div>
  );
}
